import React from "react"
import BackInStockButton, { BackInStockButtonProps } from "./"
import { useSelector } from "react-redux"
import { BaseRootState } from "../../redux/store"
import { decodeShopifyId } from "../../utils"
import { postBackInStockNotification } from "../../api/backInStock"

type ConnectedBackInStockButtonProps = Omit<BackInStockButtonProps, "onSubmit">

export default function ConnectedBackInStockButton(
  props: ConnectedBackInStockButtonProps
) {
  const { email: defaultEmail } = useSelector(
    (state: BaseRootState) => state.user
  )
  const [isLoading, setIsLoading] = React.useState(false)
  const onSubmit: BackInStockButtonProps["onSubmit"] = async ({
    email,
    name,
    phone,
    location,
    variantId,
    bikeTitle,
    listName,
    closeModal,
  }) => {
    try {
      setIsLoading(true)
      await postBackInStockNotification({
        email,
        name,
        phone,
        location,
        bikeTitle,
        listName
      })
    } catch (e) {
      console.error(e)
    }
    setIsLoading(false)
    closeModal()
  }

  return (
    <BackInStockButton
      {...props}
      defaultEmail={defaultEmail}
      isLoading={isLoading}
      onSubmit={onSubmit}
    />
  )
}
